<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <button type="button" :disabled="saving" class="back-button-wrapper pointer" aria-label="Zavrieť" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt="" />
        </button>
        <div class="blackcolor pop-800">Upraviť údaje</div>
      </div>
      <client-details-form :client="payload" @busy="saving = $event" @saved="saved" @cancel="closePopup" />
    </div>
  </div>
</template>

<script>
import ClientDetailsForm from './ClientDetailsForm.vue';
export default {
  name: 'BasicClientInformationPopUp',
  components: { ClientDetailsForm },
  props: { payload: Object },
  data: () => ({ saving: false }),
  methods: {
    saved() {
      this.$store.commit('popupManagerState/setPickerLoad', true);
      this.$store.commit('popupManagerState/popItemFromPopupOrder');
    },
    closePopup() {
      if (!this.saving) this.$store.commit('popupManagerState/popItemFromPopupOrder');
    },
  },
};
</script>
